import { lazy } from 'react';

const TransformerPageValidationMaterialConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/validation-material',
			component: lazy(() => import('./TransformerPageValidationMaterial'))
		}
	]
};

export default TransformerPageValidationMaterialConfig;
